import { render, staticRenderFns } from "./CultureMobile.vue?vue&type=template&id=856ba154&scoped=true"
import script from "./CultureMobile.vue?vue&type=script&lang=js"
export * from "./CultureMobile.vue?vue&type=script&lang=js"
import style0 from "./CultureMobile.vue?vue&type=style&index=0&id=856ba154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ba154",
  null
  
)

export default component.exports